import styled from 'styled-components';

const LandingPageContent = styled.div<{ reverse?: boolean }>`
  margin: 32px 0;
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'column-reverse' : 'column')};
  align-items: center;
  flex-shrink: 0;
  width: 100%;

  @media screen and (min-width: 960px) {
    margin-top: 0;
  }
`;

export default LandingPageContent;
